import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { routerMiddleware } from "react-router-redux"
import createBrowserHistory from "history/createBrowserHistory"
import ReduxPromise from "redux-promise"
import { loadUser } from 'redux-oidc'
import userManager from "../userManager.js"
import { reducers } from "./reducers"
import { initialstate } from './initialstate'
//import middleware from './middleware'

const history = createBrowserHistory()
const routermiddleware = routerMiddleware(history)
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore() {
  const store = createStore(
    reducers,
    initialstate, 
    composeEnhancer(applyMiddleware(thunk,routermiddleware,ReduxPromise)),
  )
  loadUser(store, userManager)
  return store
}


// WEBPACK FOOTER //
// ./src/redux/store.js